export default __webpack_public_path__ + "82b7584fb47f187d76e72dda1a847223.svg";